/** Public, browser-safe identities. Display data is always resolved for the current reader. */
export const CHAT_REFERENCE_TYPES = ['order', 'document', 'article', 'customer', 'supplier', 'return', 'quote'] as const;
export type ChatReferenceType = typeof CHAT_REFERENCE_TYPES[number];
export interface ChatReference { entityType: ChatReferenceType; entityId: string }
export interface ChatReferenceCandidate {
  start: number;
  end: number;
  source: 'number' | 'link';
  token: string;
  entityType?: ChatReferenceType;
  entityId?: string;
}
export interface ChatReferenceParseResult { version: string; candidates: ChatReferenceCandidate[] }
export interface ChatReferenceCard extends ChatReference {
  state: 'ready' | 'locked';
  label: string;
  number?: string;
  title?: string;
  status?: string;
  href?: string;
  facts?: { label: string; value: string }[];
  image?: string;
}
export const CHAT_REFERENCE_LABELS: Record<ChatReferenceType, string> = {
  order: 'Auftrag', document: 'Beleg', article: 'Artikel', customer: 'Kunde', supplier: 'Lieferant', return: 'Retoure', quote: 'Angebot',
};
export const chatReferenceKey = (ref: ChatReference) => `${ref.entityType}:${ref.entityId.toLowerCase()}`;
export function normalizeChatReferences(refs: readonly ChatReference[]): ChatReference[] {
  return [...new Map(refs.map((r) => [chatReferenceKey(r), { entityType: r.entityType, entityId: r.entityId.toLowerCase() }])).values()];
}
